import { render, staticRenderFns } from "./ProductListView.vue?vue&type=template&id=1a4f2485&scoped=true"
import script from "./ProductListView.vue?vue&type=script&lang=js"
export * from "./ProductListView.vue?vue&type=script&lang=js"
import style0 from "./ProductListView.vue?vue&type=style&index=0&id=1a4f2485&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4f2485",
  null
  
)

export default component.exports